import React from "react";
import { withRouter } from "react-router-dom";
import apiClient from "./utils/apiClient";
import { FormattedMessage, injectIntl } from "react-intl";
import RedirectToLuckyDraw from "./RedirectToLuckyDraw";

const maskPhone = (countryCode, number) => {
  if (countryCode === "852") {
    return number.slice(0, 4) + " " + number.slice(4).replace(/./g, "*");
  } else {
    return (
      number.slice(0, 3) +
      " " +
      number.slice(3, 8).replace(/./g, "*") +
      number.slice(8)
    );
  }
};

class Result extends React.Component {
  state = {
    qrcode: null,
    success: null,
    code: null,
    duplicatedEmail: false,
    duplicatedPhone: false
  };

  componentDidMount() {
    this.startFetching();
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  startFetching() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.timer = setTimeout(async () => {
      this.fetchLink();
    }, 10000);
  }

  async fetchLink() {
    const successResult = await this.fetchSuccess();
    if (!successResult) {
      const failResult = await this.fetchFail();
      if (!failResult) {
        this.startFetching();
      }
    }
  }

  async fetchSuccess() {
    try {
      const { data } = await apiClient.get(this.props.successURL);
      const { messageId, qrcode, code, email } = data;
      if (messageId === this.props.messageId) {
        this.setState({
          qrcode,
          code,
          email
        });
      }
    } catch (e) {
      return false;
    }

    return true;
  }

  async fetchFail() {
    try {
      const { data } = await apiClient.get(this.props.failURL);
      const { code, duplicatedEmail, duplicatedPhone } = data;
      this.setState({
        qrcode: null,
        code,
        duplicatedEmail,
        duplicatedPhone
      });
    } catch (e) {
      return false;
    }

    return true;
  }

  renderCapture() {
    const axel = Math.random() + "";
    const a = axel * 10000000000000;
    return (
      <>
        <img
          src="https://avn.innity.com/conversion/?conversion=1211"
          width="1"
          height="1"
          border="0"
        />
        <script type="text/javascript">
          <iframe
            src={`https://5583445.fls.doubleclick.net/activityi;src=5583445;type=invmedia;cat=newwo000;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=${a}?`}
            width="1"
            height="1"
            frameBorder="0"
            style={{ display: "none" }}
          />
        </script>
        <noscript>
          <iframe
            src="https://5583445.fls.doubleclick.net/activityi;src=5583445;type=invmedia;cat=newwo000;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?"
            width="1"
            height="1"
            frameBorder="0"
            style={{ display: "none" }}
          />
        </noscript>
      </>
    );
  }

  renderResult() {
    if (this.state.qrcode) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "rsvpFormSubmitted",
        userid: this.props.userid,
        token: this.props.token,
        project: "TPF3"
      });
      return (
        <>
          <p className="mb-6 text-base font-bold">
            <FormattedMessage id="result.success.title" />
          </p>

          <p className="mb-6">
            <FormattedMessage id="result.success.body" />
          </p>

          <RedirectToLuckyDraw prefill={this.state.qrcode} />
          <a
            href={`https://minigametw.newworldclub.com.hk/?utm_source=${
              this.props.intl.locale === "en" ? "Online_RSVP_en" : "Online_RSVP"
            }&utm_medium=Others&referraltoken=${this.props.token}`}
            className="bg-white px-5 py-4 text-explore cursor-pointer inline-block"
          >
            <FormattedMessage id="result.exploreMore" />
          </a>
        </>
      );
    } else if (this.state.code === null) {
      return (
        <div>
          <p className="text-center mb-8">
            <FormattedMessage id="result.loading" />
          </p>
          <div className="text-center flex justify-center">
            <img src={require("./assets/loading.gif")} alt="loading" />
          </div>
        </div>
      );
    } else if (this.state.duplicatedPhone) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "reservation_repeat",
        token: this.props.token,
        project: "TPF3"
      });
      return (
        <>
          <p className="mb-6 text-base font-bold">
            <FormattedMessage id="result.duplicatedPhone.title" />
          </p>

          <p className="mb-6">
            <FormattedMessage id="result.duplicatedPhone.body" />
          </p>
          <a
            href={`https://minigametw.newworldclub.com.hk/?utm_source=${
              this.props.intl.locale === "en" ? "Online_RSVP_en" : "Online_RSVP"
            }&utm_medium=Others&referraltoken=${this.props.token}`}
            className="bg-white px-5 py-4 text-explore cursor-pointer inline-block"
          >
            <FormattedMessage id="result.exploreMore" />
          </a>
        </>
      );
    } else if (this.state.duplicatedEmail) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "reservation_repeat",
        token: this.props.token,
        project: "TPF3"
      });
      return (
        <>
          <p className="mb-6 text-base font-bold">
            <FormattedMessage id="result.duplicatedEmail.title" />
          </p>
          <a
            href={`https://minigametw.newworldclub.com.hk/?utm_source=${
              this.props.intl.locale === "en" ? "Online_RSVP_en" : "Online_RSVP"
            }&utm_medium=Others&referraltoken=${this.props.token}`}
            className="bg-white px-5 py-4 text-explore cursor-pointer inline-block"
          >
            <FormattedMessage id="result.exploreMore" />
          </a>
        </>
      );
    } else {
      return (
        <>
          <p className="mb-6 text-base font-bold">
            <FormattedMessage id="result.full.title" />
          </p>

          <p className="mb-6">
            <FormattedMessage id="result.full.body" />
          </p>
          <a
            href={`https://minigametw.newworldclub.com.hk/?utm_source=${
              this.props.intl.locale === "en" ? "Online_RSVP_en" : "Online_RSVP"
            }&utm_medium=Others&referraltoken=${this.props.token}`}
            className="bg-white px-5 py-4 text-explore cursor-pointer inline-block"
          >
            <FormattedMessage id="result.exploreMore" />
          </a>
        </>
      );
    }
  }

  render() {
    return (
      <div className="h-full flex items-center justify-center text-xs text-center text-white">
        <div>
          <div>{this.renderResult()}</div>
        </div>
      </div>
    );
  }
}

export default injectIntl(withRouter(Result));
